/* legacy-fix.js
 * 古いテーマ用に、jQuery 3 で削除された/挙動が変わったメソッドを補完する
 * - .live()
 * - .size()
 * - .bind() / .unbind()
 * - .delegate() / .undelegate()
 * - .toggle(fn, fn, ...)
 * - .load(fn) （イベントショートハンド）
 */
(function($) {
  // ============================
  // 1) .live() ポリフィル
  // ============================
  if (typeof $.fn.live === 'undefined') {
    $.fn.live = function(events, handler) {
      // live はセレクタベース前提なので、this.selector が必要
      if (!this.selector) {
        return this;
      }
      // document にデリゲート
      $(document).on(events, this.selector, handler);
      return this;
    };
  }

  // ============================
  // 2) .size() ポリフィル
  // ============================
  if (typeof $.fn.size === 'undefined') {
    $.fn.size = function() {
      return this.length;
    };
  }

  // ============================
  // 3) .bind() / .unbind() ポリフィル
  // ============================
  if (typeof $.fn.bind === 'undefined') {
    $.fn.bind = function(/* types, [data], fn */) {
      // jQuery 3 の .on にそのまま委譲
      return this.on.apply(this, arguments);
    };
  }

  if (typeof $.fn.unbind === 'undefined') {
    $.fn.unbind = function(/* types, fn */) {
      // jQuery 3 の .off に委譲
      return this.off.apply(this, arguments);
    };
  }

  // ============================
  // 4) .delegate() / .undelegate() ポリフィル
  // ============================
  if (typeof $.fn.delegate === 'undefined') {
    $.fn.delegate = function(selector, types, data, fn) {
      // (selector, types, fn) / (selector, types, data, fn) どちらにもそこそこ対応
      if (typeof data === 'function') {
        fn = data;
        data = undefined;
      }
      return this.on(types, selector, data, fn);
    };
  }

  if (typeof $.fn.undelegate === 'undefined') {
    $.fn.undelegate = function(selector, types, fn) {
      // jQuery の off と同じ引数順
      return this.off(types, selector, fn);
    };
  }

  // ============================
  // 5) .toggle(fn, fn, ...) 古いクリックトグルを復活
  // ============================
  var _oldToggle = $.fn.toggle;
  $.fn.toggle = function(fn) {
    // 最初の引数が function の場合は、古い click-toggle 機能と判断
    if (typeof fn === 'function') {
      var funcs = Array.prototype.slice.call(arguments); // [fn1, fn2, fn3, ...]
      return this.each(function() {
        var i = 0;
        $(this).off('click._legacyToggle') // 重複防止
               .on('click._legacyToggle', function(e) {
                  funcs[i].call(this, e);
                  i = (i + 1) % funcs.length;
               });
      });
    }

    // それ以外は元の toggle (show/hide 用) に任せる
    if (typeof _oldToggle === 'function') {
      return _oldToggle.apply(this, arguments);
    }
    return this; // 念のため
  };

  // ============================
  // 6) .load(fn) イベントショートハンドの互換
  // ============================
  var _oldLoad = $.fn.load;
  $.fn.load = function(url, data, complete) {
    // .load(fn) 形式 → load イベントハンドラとして扱う
    if (typeof url === 'function') {
      return this.on('load', url);
    }

    // 旧 Ajax .load(url, data, complete) 形式は、元の実装があればそちらへ
    if (typeof _oldLoad === 'function') {
      return _oldLoad.apply(this, arguments);
    }

    // ここまで来るケースはほぼ無いはずなので、そのまま返す
    return this;
  };

})(jQuery);

  // ============================
  // 7) .live() を復活させるポリフィル
  // ============================

  (function($) {
    if (!$.fn.live) {
      $.fn.live = function(events, data, callback) {
        // 第2引数が省略されて data が callback のパターンにも対応
        if ($.isFunction(data) || data === false) {
          callback = data;
          data = undefined;
        }

        // live はセレクタベースなので、this.selector がないとどうしようもない
        if (!this.selector) return this;

        // 古い live は document にデリゲートしていたので同じ動きを再現
        $(document).on(events, this.selector, data, callback);

        return this;
      };
    }
  })(jQuery);